export const jsonSafeParse = (jsonString) => {
  try {
    const json = JSON.parse(jsonString);
    return json;
  } catch (e) {
    console.error('Error json parsing', e);
    return null;
  }
}